import { render, staticRenderFns } from "./upgrade-banner.vue?vue&type=template&id=416a0396&scoped=true&"
import script from "./upgrade-banner.vue?vue&type=script&lang=js&"
export * from "./upgrade-banner.vue?vue&type=script&lang=js&"
import style0 from "./upgrade-banner.vue?vue&type=style&index=0&id=416a0396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416a0396",
  null
  
)

export default component.exports